/* eslint-disable import/prefer-default-export */

export const getCurArea = ({ reportedArea, boundaryArea }) =>
  reportedArea > 0 ? reportedArea : boundaryArea;

export const calculateFarmAcres = fields =>
  fields.reduce((prev, curr) => prev + getCurArea(curr), 0);
